import { render } from "./TheQuanHuyen.vue?vue&type=template&id=65a06330"
import script from "./TheQuanHuyen.vue?vue&type=script&lang=js"
export * from "./TheQuanHuyen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__